import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import './style.scss';

// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX_VALIDATOR = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const ENTER_KEY_CODE = 13;

export class EmailSelection {
    allEmails = [];

    emailOptions = [];

    isValid = false;

    isEmailOptionListOpened = false;

    selectedEmails = [];

    currentEmailState = {
        isValid: false,
        email: ''
    };

    /* @ngInject */
    constructor(utils, $timeout, DOMAIN_CONFIG) {
        this.utils = utils;
        this.$timeout = $timeout;
        this.domainConfig = DOMAIN_CONFIG;
    }

    $onChanges() {
        this.updateEmailOptions();
        this.updateValidationState();
    }

    updateEmailOptions() {
        const selectedEmailsHash = this.getSelectedEmailHash();
        const currentEmail = this.currentEmailState.email;
        const filteredEmails = _
            .uniqBy(this.allEmails, ({ value }) => value)
            .reduce((options, email) => {
                const isEmailSelected = selectedEmailsHash[email.value];
                const isEmailSatisfyQuery = email.value.indexOf(currentEmail.value) !== -1;
                const canAddEmail = !isEmailSelected && isEmailSatisfyQuery;

                if (canAddEmail) {
                    return [
                        ...options, {
                            value: email,
                            label: email.value
                        },
                    ];
                }

                return options;
            }, []);

        this.emailOptions = this.utils.getFirstOfList(filteredEmails, this.domainConfig.SHOW_LIST_ITEMS);
    }

    updateValidationState() {
        this.isValid = (this.selectedEmails || []).length !== 0;
    }

    onKeyPress(event) {
        const keyCode = event.which || event.keyCode;

        if (keyCode === ENTER_KEY_CODE) {
            event.preventDefault();
            this.onEnterPress();
        }
    }

    onInputChange() {
        this.updateCurrentEmailState(this.currentEmailState.email);
    }

    onInputClick(event) {
        const email = event.target.value;

        this.updateCurrentEmailState({ value: email });
        this.isEmailOptionListOpened = true;
    }

    clearCurrentEmailState() {
        this.updateCurrentEmailState({ value: '' });
    }

    updateCurrentEmailState(email) {
        this.currentEmailState = {
            email,
            isValid: this.isValidEmail(email.value)
        };
        this.updateEmailOptions();
        this.updateValidationState();
    }

    onEnterPress() {
        if (this.currentEmailState.isValid) {
            this.addEmail(this.currentEmailState.email);
        }
        this.isEmailOptionListOpened = false;
    }

    onBlurChange() {
        if (this.currentEmailState.isValid) {
            this.addEmail(this.currentEmailState.email);
        }

        window.setTimeout(() => this.isEmailOptionListOpened = false);
    }

    onOptionSelect(option) {
        this.addEmail(option.value);
    }

    addEmail(email) {
        if (!(this.selectedEmails || []).find(selectedEmail => selectedEmail.value === email.value)) {

            const selectedEmails = [
                ...this.selectedEmails || [], {
                    value: email.value,
                    canRemove: true,
                }
            ];

            this.onSelectedEmailsChanged({ selectedEmails });
            this.clearCurrentEmailState();
            this.updateValidationState();
        } else {
            this.clearCurrentEmailState();
        }
    }

    removeEmail(email) {
        if (email.canRemove) {
            const selectedEmails = this.utils.removeFromArray([...this.selectedEmails || [ ]], email);

            this.onSelectedEmailsChanged({ selectedEmails });
            this.updateValidationState();
        }
    }

    getSelectedEmailHash() {
        return (this.selectedEmails || []).reduce((currentHash, email) => {
            currentHash[email.value] = true;

            return currentHash;
        }, {});
    }

    isValidEmail(email = '') {
        return EMAIL_REGEX_VALIDATOR.test(email);
    }
}

export const EmailSelectionConfiguration = {
    template,
    bindings: {
        allEmails: '<',
        selectedEmails: '<',
        onSelectedEmailsChanged: '&'
    },
    controller: EmailSelection,
    controllerAs: 'emailSelectionCtrl'
};

angular.module('TALENYA-FE')
    .component('emailSelection', EmailSelectionConfiguration);
